import { render, staticRenderFns } from "./FilterItemMenuItem.vue?vue&type=template&id=07116910&scoped=true&"
import script from "./FilterItemMenuItem.vue?vue&type=script&lang=js&"
export * from "./FilterItemMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07116910",
  null
  
)

export default component.exports